<template>
    <div class="py-4 container-fluid">
        <!--    {{this.guest_id}}-->
        <button class="btn btn-sm tnkc-secondary mb-2 text-white float-right" @click="goBack">
            <font-awesome-icon icon="undo"/>
            Go Back
        </button>
        <button class="btn btn-sm tnkc-warning mb-2 mx-3 float-right"
                style="display: block" id="btnEdit"
                @click="editGuest">
            <font-awesome-icon icon="edit"/>
            Edit
        </button>
        <button class="btn btn-sm tnkc-danger mb-2 mx-3 float-right"
                style="display: none" id="btnCancel"
                @click="editGuest">
            <font-awesome-icon icon="times"/>
            Cancel
        </button>
        <h4 class="h4 font-weight-bold text-left text-capitalize">Guest Profile</h4>
        <hr/>
        <form @submit.prevent="update_guest" id="editGuest" class="mb-5">
            <table class="table table-borderless table-sm text-left mb-0">
                <tbody>
                <tr>
                    <td class="bg-light p-3" rowspan="8" style="width: 200px; box-sizing: border-box;">
                        <img :src="tnkcBanner" alt="" style="width: 100%; height: auto;">
                        <!--<button type="button" id="uploadImg" class="btn btn-sm tnkc-success" style="display: none; margin: 0 auto">
                            Upload
                        </button>-->
                    </td>
                    <td class="px-3" style="width: 150px;">
                        <label for="fName" class="col-form-label font-weight-bold">FIRST NAME</label>
                    </td>
                    <td style="width: 30px; font-weight: bold;">
                        <label for="fName" class="col-form-label font-weight-bold">:</label>
                    </td>
                    <td>
                        <input type="text" class="form-control col-form-label-sm bg-white" id="fName" style="border: 0"
                               :value="guest.first_name" :disabled="disabledInput" v-if="disabledInput">
                        <input type="text" class="form-control col-form-label-sm bg-white" id="fNameEdit"
                               v-model="guest.first_name" v-else>
                    </td>
                </tr>
                <tr>
                    <td class="px-3" style="width: 150px;">
                        <label for="mName" class="col-form-label font-weight-bold">MIDDLE NAME</label>
                    </td>
                    <td style="width: 30px; font-weight: bold;">
                        <label for="mName" class="col-form-label font-weight-bold">:</label></td>
                    <td>
                        <input type="text" class="form-control col-form-label-sm bg-white" id="mName" style="border: 0"
                               :value="guest.middle_name" :disabled="disabledInput" v-if="disabledInput">
                        <input type="text" class="form-control col-form-label-sm bg-white" id="mNameEdit"
                               v-model="guest.middle_name" v-else>
                    </td>
                </tr>
                <tr>
                    <td class="px-3" style="width: 150px;">
                        <label for="lName" class="col-form-label font-weight-bold">LAST NAME</label>
                    </td>
                    <td style="width: 30px; font-weight: bold;">
                        <label for="lName" class="col-form-label font-weight-bold">:</label></td>
                    <td>
                        <input type="text" class="form-control col-form-label-sm bg-white" id="lName" style="border: 0"
                               :value="guest.last_name" :disabled="disabledInput" v-if="disabledInput">
                        <input type="text" class="form-control col-form-label-sm bg-white" id="lNameEdit"
                               v-model="guest.last_name" v-else>
                    </td>
                </tr>
                <tr>
                    <td class="px-3" style="width: 150px;">
                        <label for="suffix" class="col-form-label font-weight-bold">SUFFIX</label>
                    </td>
                    <td style="width: 30px; font-weight: bold;">
                        <label for="suffix" class="col-form-label font-weight-bold">:</label></td>
                    <td>
                        <input type="text" class="form-control col-form-label-sm bg-white" id="suffix" style="border: 0"
                               :value="guest.suffix_name" :disabled="disabledInput" v-if="disabledInput">
                        <input type="text" class="form-control col-form-label-sm bg-white" id="suffixEdit"
                               v-model="guest.suffix_name" v-else>
                    </td>
                </tr>
                <tr>
                    <td class="px-3" style="width: 150px;">
                        <label for="company" class="col-form-label font-weight-bold">COMPANY</label>
                    </td>
                    <td style="width: 30px; font-weight: bold;">
                        <label for="company" class="col-form-label font-weight-bold">:</label></td>
                    <td>
                        <input type="text" class="form-control col-form-label-sm bg-white" id="company" style="border: 0"
                               :value="guest.company" :disabled="disabledInput" v-if="disabledInput">
                        <input type="text" class="form-control col-form-label-sm bg-white" id="companyEdit"
                               v-model="guest.company" v-else>
                    </td>
                </tr>
                <tr>
                    <td class="px-3" style="width: 150px;">
                        <label for="address" class="col-form-label font-weight-bold">ADDRESS</label>
                    </td>
                    <td style="width: 30px; font-weight: bold;">
                        <label for="address" class="col-form-label font-weight-bold">:</label></td>
                    <td>
                        <input type="text" class="form-control col-form-label-sm bg-white" id="address" style="border: 0"
                               :value="guest.address" :disabled="disabledInput" v-if="disabledInput">
                        <input type="text" class="form-control col-form-label-sm bg-white" id="addressEdit"
                               v-model="guest.address" v-else>
                    </td>
                </tr>
                <tr>
                    <td class="px-3" style="width: 150px;">
                        <label for="email" class="col-form-label font-weight-bold">EMAIL</label>
                    </td>
                    <td style="width: 30px; font-weight: bold;">
                        <label for="email" class="col-form-label font-weight-bold">:</label></td>
                    <td>
                        <input type="text" class="form-control col-form-label-sm bg-white" id="email" style="border: 0"
                               :value="guest.email" :disabled="disabledInput" v-if="disabledInput">
                        <input type="text" class="form-control col-form-label-sm bg-white" id="emailEdit"
                               v-model="guest.email" v-else>
                    </td>
                </tr>
                <tr>
                    <td class="px-3" style="width: 150px;">
                        <label for="contactNum" class="col-form-label font-weight-bold">PHONE NUMBER</label>
                    </td>
                    <td style="width: 30px; font-weight: bold;">
                        <label for="contactNum" class="col-form-label font-weight-bold">:</label></td>
                    <td>
                        <input type="text" class="form-control col-form-label-sm bg-white" id="contactNum" style="border: 0"
                               :value="guest.contact_number" :disabled="disabledInput" v-if="disabledInput">
                        <input type="text" class="form-control col-form-label-sm bg-white" id="contactNumEdit"
                               v-model="guest.contact_number" v-else>
                    </td>
                </tr>
                </tbody>
            </table>
            <button class="btn btn-sm tnkc-primary float-right" type="submit"
                    style="display: none" id="btnUpdateGuest">
                <font-awesome-icon icon="save"/>
                Update Guest
            </button>
        </form>
        <div class="row">
            <div class="col-sm-12">
                <ul class="nav nav-tabs" id="guestBooking" role="tablist">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link font-weight-bold active"
                           id="bookingHistoryNav"
                           data-toggle="tab"
                           href="#bookingHistory"
                           role="tab"
                           aria-controls="experience"
                           aria-selected="true">
                            Booking History
                        </a>
                    </li>
                    <li class="nav-item" role="presentation">
                        <a class="nav-link font-weight-bold"
                           id="currentBookingNav"
                           data-toggle="tab"
                           href="#currentBooking"
                           role="tab"
                           aria-controls="experience"
                           aria-selected="true">
                            Active Booking
                        </a>
                    </li>
                </ul>
                <div class="tab-content border-top-0 border-left border-right border-bottom">
                    <div class="tab-pane fade show p-2 text-center active" id="bookingHistory" role="tabpanel" aria-labelledby="bookingHistoryNav">
                        <div class="card">
                          <div class="card-header">
                            <h4 class="h4 text-left font-weight-bold">Guest Booking History</h4>
                          </div>
                          <div class="card-body">
                            <div class="table table-responsive-sm">
                              <table class="table table-bordered">
                                <thead>
                                <tr class="tnkc-secondary">
                                  <th scope="col" class="p-1 align-middle">#</th>
                                  <th scope="col" class="p-1 align-middle">Floor —> Room —> Bed</th>
                                  <th scope="col" class="p-1 align-middle">Booked Check-in</th>
                                  <th scope="col" class="p-1 align-middle">Booked Check-Out</th>
                                  <th scope="col" class="p-1 align-middle">Check In</th>
                                  <th scope="col" class="p-1 align-middle">Check Out</th>
                                  <th scope="col" class="p-1 align-middle">Status</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(guestBooked,index) in guestBookedHistory" :key="guestBooked.id">
                                  <th scope="row" class="p-1 align-middle" width="20">{{index + 1}}</th>
                                  <td class="p-1 align-middle">{{guestBooked.floor ? guestBooked.floor : ''}} —> {{guestBooked.room ? guestBooked.room : ''}} —> {{guestBooked.bed ? guestBooked.bed : ''}}</td>
                                  <td class="p-1 align-middle">{{guestBooked.booked_check_in | moment('D MMM YYYY') }}</td>
                                  <td class="p-1 align-middle">{{guestBooked.booked_check_out | moment('D MMM YYYY') }}</td>
                                  <td class="p-1 align-middle">{{guestBooked.check_in | moment('D MMM YYYY') }}</td>
                                  <td class="p-1 align-middle">{{guestBooked.check_out | moment('D MMM YYYY') }}</td>
                                  <td class="p-1 align-middle">{{guestBooked.status}}</td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                    </div>


                    <div class="tab-pane fade show p-2 text-center" id="currentBooking" role="tabpanel" aria-labelledby="currentBookingNav">
                      <div class="card">
                        <div class="card-header">
                          <h4 class="h4 text-left font-weight-bold">Current / Active Booking</h4>
                        </div>
                        <div class="card-body">
                          <div class="table table-responsive-sm">
                            <table class="table table-bordered">
                              <thead>
                              <tr class="tnkc-secondary">
                                <th scope="col" class="p-1 align-middle">#</th>
                                <th scope="col" class="p-1 align-middle">Floor —> Room —> Bed</th>
                                <th scope="col" class="p-1 align-middle">Booked Check-in</th>
                                <th scope="col" class="p-1 align-middle">Booked Check-Out</th>
                                <th scope="col" class="p-1 align-middle">Check In</th>
                                <th scope="col" class="p-1 align-middle">Check Out</th>
                                <th scope="col" class="p-1 align-middle">Status</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr>
                                <th scope="row" class="p-1 align-middle" width="20">--</th>
                                <td class="p-1 align-middle">{{guestLatestBooked.floor}} —> {{guestLatestBooked.room}} —> {{guestLatestBooked.bed}}</td>
                                <td class="p-1 align-middle">{{guestLatestBooked.booked_check_in | moment('D MMM YYYY') }}</td>
                                <td class="p-1 align-middle">{{guestLatestBooked.booked_check_out | moment('D MMM YYYY') }}</td>
                                <td class="p-1 align-middle">{{guestLatestBooked.check_in | moment('D MMM YYYY') }}</td>
                                <td class="p-1 align-middle">{{guestLatestBooked.check_out | moment('D MMM YYYY') }}</td>
                                <td class="p-1 align-middle">{{guestLatestBooked.status}}</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import {appMixins} from '../../mixins/app.mixins';
  import TnkcBanner from '../../assets/tnkc-banner.png';

  export default {
    name: 'GuestProfile',
    mixins: [appMixins],
    props: ['guest_id'],
    data() {
      return {
        //todo
        tnkcBanner: TnkcBanner,
        disabledInput: true,
      };
    },

    methods: {
      //todo
      ...mapActions(['viewGuestDetails', 'deleteGuest', 'updateGuest']),
      editGuest() {
        let btnCancel = document.getElementById('btnCancel');
        let btnEdit = document.getElementById('btnEdit');
        let btnUpdateGuest = document.getElementById('btnUpdateGuest');
        let formEditGuest = document.getElementById('editGuest');

        if (btnEdit.style.display === 'block') {
          this.disabledInput = !this.disabledInput;
          btnCancel.style.display = 'block';
          btnEdit.style.display = 'none';
          btnUpdateGuest.style.display = 'block';
          document.getElementById(formEditGuest.elements[0].id).style.display = 'block';
        } else if (btnCancel.style.display === 'block') {
          this.disabledInput = !this.disabledInput;
          btnCancel.style.display = 'none';
          btnEdit.style.display = 'block';
          btnUpdateGuest.style.display = 'none';
          document.getElementById(formEditGuest.elements[0].id).style.display = 'none';
        }
      },

      async update_guest() {
        if (await this.questionAlert('Are you sure you want to save your changes.', 'UPDATE')) {
          this.updateGuest(this.decapitalizeObject(this.guest)).then((res) => {
            if (res == true) {
              this.successAlert('Update guest details successfully.', 'UPDATE');
              this.editGuest();
            }
          });
        }
      },
    },

    created() {
      //todo
      this.viewGuestDetails(this.guest_id);

    },

    mounted() {
      //todo
    },

    destroyed() {
      //todo
    },

    computed: {
      ...mapGetters(['guest','guestBookedHistory','guestLatestBooked']),
    },

  };
</script>

<style scoped>
    #editGuest table tr td {
        padding: 0;
    }

    #guestBooking .nav-link.active, .nav-tabs .nav-item.show .nav-link {
        background-color: #b3dcfa;
    }

</style>
